/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: checkin-result-modal-component.ts
 *
 * Created by randysorensen on 1/19/18.
 */

'use strict';

function CheckinResultModalController(
    this: JS5Object,

    _: JS5Object,
) {

    this.gridOptions = {
        enableSorting: false,
        enableFiltering: false,
        enableColumnMenus: false,
        showTreeExpandNoChildren: false,
        treeRowHeaderBaseWidth: 12,
        data: [],
        columnDefs: [
            {
                name: 'name',
                displayName: 'Spreadsheet Name',
                width: '90%',
                cellTemplate: 'dashboard/packageCheckin/components/modals/checkinResultModal/gridTemplates/result-cell-template.html',
            },
        ],
    };

    this.$onInit = (): void => {
        _.forEach(this.resolve.resultsDict, (resultsForFile: string[], fileName: string): void => {
            this.gridOptions.data.push({
                name: fileName,
                top: true,
                $$treeLevel: 0,
            });
            _.forEach(resultsForFile, (result: string): void => {
                this.gridOptions.data.push({
                    name: result,
                    $$treeLevel: 1
                });
            });
        });
    };

    this.$onDestroy = (): void => {
        this.close();
    };

}

angular.module('prism-ui.components').component('checkinResultModal', {
    templateUrl: 'dashboard/packageCheckin/components/modals/checkinResultModal/checkin-result-modal-template.html',
    controller: CheckinResultModalController,
    bindings: {
        resolve: '<',
        dismiss: '&',
        close: '&',
    }
});
